module.exports = __webpack_public_path__ + "static/media/farClause.5fc14a0c.jpg";